export default "__VITE_ASSET__BFtBRNkE__"